const configs = {
    alpha: {
        AppWebDomain: 'digital-security-automation-zest-alpha.auth.us-west-2.amazoncognito.com',
        ClientId: '20nu6dg0ftb5np0l7la37an12s',
        RedirectUriSignIn: window.location.origin,
        RedirectUriSignOut: window.location.origin,
        TokenScopesArray: ['openid', 'profile'],
        UserPoolId: 'us-west-2_9Fv9ZOvZ4'
    },
    prod: {
        AppWebDomain: 'digital-security-automation-zest-prod.auth.us-west-2.amazoncognito.com',
        ClientId: '5ea1cf5heqqhv5k9cle1cuquqg',
        RedirectUriSignIn: window.location.origin,
        RedirectUriSignOut: window.location.origin,
        TokenScopesArray: ['openid', 'profile'],
        UserPoolId: 'us-west-2_Xr5UiEyb0'
    }
}

export function getAuthConfig(env) {
    // If no environment is passed, try to get it from envVarsReader
    if (!env) {
        try {
            const envModule = require('./envVarsReader');
            env = envModule.getCurEnv();
        } catch (e) {
            // Fallback to prod if there's any issue
            env = 'prod';
        }
    }
    
    // Default to prod if environment is not set or not recognized
    const environment = (env != 'prod') ? 'alpha' : 'prod';
    
    return configs[environment];
}